import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import TitleChangeLog from './title-change-log-model'
import {
  CreateTitleChangeLogAsync,
  DeleteTitleChangeLogAsync,
  LoadTitleChangeLogsAsync,
} from './titleChangeLog-thunk'
const initialState: titleChangeLogSliceState = {
  titleChangeLog: [],
  selected_titleChangeLog: '',
  is_loading_titleChangeLog: false,
  is_creating_titleChangeLog: false,
  is_deleting_titleChangeLog: false,
}
export interface titleChangeLogSliceState {
  titleChangeLog: TitleChangeLog[]
  selected_titleChangeLog?: string
  is_loading_titleChangeLog: boolean
  is_creating_titleChangeLog: boolean
  is_deleting_titleChangeLog: boolean
}
export const titleChangeLogSlice = createSlice({
  name: 'titleChangeLog',
  initialState,
  reducers: {
    setSelectedtitleChangeLog: (state, action) => {
      state.selected_titleChangeLog = action.payload
    },
    clearStatetitleChangeLog: (state) => {
      state.titleChangeLog = []
      state.is_loading_titleChangeLog = false
      state.is_creating_titleChangeLog = false
      state.is_deleting_titleChangeLog = false
    },
    mergetitleChangeLog: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_titleChangeLog = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.titleChangeLog = merge(state.titleChangeLog, payload) as any
        }
      }
    },

    add_titleChangeLog: (state, action) => {
      if (action.payload) {
        state.titleChangeLog = [...state.titleChangeLog, action.payload]
      }
    },
    set_titleChangeLog: (state, action) => {
      let { key, value, id } = action.payload
      state.titleChangeLog = state.titleChangeLog.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadTitleChangeLogsAsync.pending, (state) => {
      state.is_loading_titleChangeLog = true
    })
    builder.addCase(LoadTitleChangeLogsAsync.fulfilled, (state, action) => {
      state.is_loading_titleChangeLog = false
      if (action.payload) {
        state.titleChangeLog = action.payload
      }
    })
    builder.addCase(LoadTitleChangeLogsAsync.rejected, (state) => {
      state.is_loading_titleChangeLog = false
    })
    builder.addCase(CreateTitleChangeLogAsync.pending, (state) => {
      state.is_creating_titleChangeLog = true
    })
    builder.addCase(CreateTitleChangeLogAsync.fulfilled, (state) => {
      state.is_creating_titleChangeLog = false
    })
    builder.addCase(CreateTitleChangeLogAsync.rejected, (state) => {
      state.is_creating_titleChangeLog = false
    })
    builder.addCase(DeleteTitleChangeLogAsync.pending, (state) => {
      state.is_deleting_titleChangeLog = true
    })
    builder.addCase(DeleteTitleChangeLogAsync.fulfilled, (state, action) => {
      state.is_deleting_titleChangeLog = false
      if (state.titleChangeLog) {
        state.titleChangeLog = state.titleChangeLog.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteTitleChangeLogAsync.rejected, (state) => {
      state.is_deleting_titleChangeLog = false
    })
  },
})

export const {
  clearStatetitleChangeLog,
  setSelectedtitleChangeLog,
  set_titleChangeLog,
  mergetitleChangeLog,
  add_titleChangeLog,
} = titleChangeLogSlice.actions

export const get_titleChangeLog =
  (id?: string) =>
  (state: {
    titleChangeLog: {
      titleChangeLog: TitleChangeLog[]
    }
  }): TitleChangeLog | null => {
    let temp = state?.titleChangeLog?.titleChangeLog?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.titleChangeLog?.titleChangeLog[0] || null
  }
export const get_selected_titleChangeLog = (state: {
  titleChangeLog: titleChangeLogSliceState
}): TitleChangeLog | null => {
  let id = state?.titleChangeLog?.selected_titleChangeLog
  let temp = state?.titleChangeLog?.titleChangeLog?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_titleChangeLog = (state: {
  titleChangeLog: {
    titleChangeLog: TitleChangeLog[]
  }
}): TitleChangeLog[] => {
  let temp = state?.titleChangeLog?.titleChangeLog
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_titleChangeLog_busy = (state: {
  titleChangeLog: titleChangeLogSliceState
}) => {
  return (
    state?.titleChangeLog.is_deleting_titleChangeLog ||
    state?.titleChangeLog.is_loading_titleChangeLog ||
    state?.titleChangeLog.is_creating_titleChangeLog
  )
}
export const is_deleting_titleChangeLog_busy = (state: {
  titleChangeLog: titleChangeLogSliceState
}) => {
  return state?.titleChangeLog.is_deleting_titleChangeLog
}
export const is_loading_titleChangeLog_busy = (state: {
  titleChangeLog: titleChangeLogSliceState
}) => {
  return state?.titleChangeLog.is_loading_titleChangeLog
}
export const is_creating_titleChangeLog_busy = (state: {
  titleChangeLog: titleChangeLogSliceState
}) => {
  return state?.titleChangeLog.is_creating_titleChangeLog
}

export default titleChangeLogSlice.reducer
